import Axios from 'axios';
import {Configuration} from "./Configuration";


class DateAPI {
  url: string = `${Configuration.apiUrl}/date.php`;

  currentCET(): Promise<string> {
    return Axios.get(`${this.url}`);
  }
}

export default DateAPI;
